import { render, staticRenderFns } from "./_404.vue?vue&type=template&id=3ab90b04"
import script from "./_404.vue?vue&type=script&lang=js"
export * from "./_404.vue?vue&type=script&lang=js"
import style0 from "./_404.vue?vue&type=style&index=0&id=3ab90b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports